/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();

      // A custom element has no implicit role and no tab stop, and this one
      // contains nothing but an SVG — so Tab never reached it and screen
      // readers had nothing to announce. Removing a line was mouse-only, with
      // no alternative: quantity 0 is blocked by min="1" on the input.
      // Same treatment PanelClose and QuickView already get in app.js.
      if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          this.dispatchEvent(new CustomEvent('cart:remove', {
            bubbles: true,
            detail: { index: this.dataset.index }
          }));
        }
      }, { signal: this.abortController.signal });

      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.dispatchEvent(new CustomEvent('cart:remove', {
          bubbles: true,
          detail: { index: this.dataset.index }
        }));
      }, { signal: this.abortController.signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  }
  customElements.define('cart-remove', CartRemove);
}